export const REQUIRED_ONBOARDING = 'required-onboarding';
export const PROMOTIONS = 'promotions';
export const PRODUCT = 'product';
export const PURCHASE_MOTIONS = 'purchase-motions';
export const RETAIL = 'retail';
export const CONTACTS = 'contacts';
export const MARKETING_CONTACTS_RENEWAL = 'marketing-contacts-on-mc-renewal';
export const MARKETING_CONTACTS_SWITCH = 'marketing-contacts-on-mc-switch';
export const PHONE_NUMBER = 'phone-number';
export const PUBLIC_META = 'public-meta';
export const PRODUCT_INVENTORY = 'product-inventory';
export const IDENTIFICATION_TOKEN = 'identification-token';
export const SEATS_INVENTORY = 'seats-inventory';
export const LIMIT_USAGE = 'limit-usage';
export const FEATURE_INTEREST = 'feature-interest';
export const FEATURES_DEFAULTS = 'features-defaults';
export const COOKIE_ECHO_USER = 'cookie-echo-user';
export const HSFS_APPLICATION_STATUS = 'HSFSApplicationStatus';
export const CURRENCY = 'currency';